import {useSelector} from 'react-redux';
import PermissionCheck from '../../Components/PermissionCheck';
import React from 'react';
import BasicInfo from './BasicInfo';
import PROFILE_TYPE from '../../../../../constants/profileTypes';

const permission = {
    [PROFILE_TYPE.ENQUIRY]: 'EnquiryProfile',
    [PROFILE_TYPE.APPLICATION]: 'ApplicantProfile',
    [PROFILE_TYPE.STUDENT]: 'StudentProfile',
};

const BasicInfoTab = () => {
    const personType = useSelector(state => state.profilesInfo.selectedProfile.personType);
    const selectedProfile = useSelector(state => state.profilesInfo.selectedProfile);

    return (
        <PermissionCheck
            permissionModule={permission[personType]}
            render={(readonly) => <BasicInfo readonly={readonly}/>}
            studentProfile={selectedProfile}
        />
    );
};

export default BasicInfoTab;